import { PageLayout } from "../../Components/PageLayout";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMutate } from "../../Hooks/use-mutate";
import { Card } from "../../Components/ui/card";
import { Form } from "../../Components/ui/form/form";
import { FieldWrapper } from "../../Components/ui/form/field-wrapper";

type MaintenanceReportSubmit = {
  vehicle_type: "truck" | "trailer";
  vehicle_id: number;
  odometer: number | null;
  location: number;
  assigned_spot: string;
  notes: string;
};

const CreateMaintenanceReportRoute = () => {
  const { t } = useTranslation();
  const createReport = useMutate<MaintenanceReportSubmit>(
    "safety/create-maintenance-report",
    "POST",
  );

  const navigate = useNavigate();

  const handleSubmit = async (event: React.SubmitEvent) => {
    event.preventDefault();
  };

  return (
    <PageLayout
      title={"Create Maintenance Report"}
      header={""}
    >
      <Card
        title="createMaintenanceReport"
        titleKey="createMaintenanceReport"
        size="md"
      >
        <Form
          onSubmit={handleSubmit}
          isLoading={createReport.isLoading}
          submitLabel="create"
          cancel={() => navigate("/maintenance-reports")}
        >
          <FieldWrapper label="vehicleType">
            <div className="">
              <input type="radio" name="vehicleType" value="truck"/> 
              <input type="radio" name="vehicleType" value="trailer"/> 
            </div>
          </FieldWrapper>
        </Form>
      </Card>
    </PageLayout>
  );
};

export default CreateMaintenanceReportRoute;
